// CohostInbox — polls /api/cohost/inbox/{streamId} every 5s and shows accept/decline for
// each pending cohost request. Streamer only.
import { useEffect, useState } from "react";
import { UserCheck, UserX, Users } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function CohostInbox({ streamId }) {
  const [items, setItems] = useState([]);
  const load = () => api.get(`/cohost/inbox/${streamId}`).then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); /* eslint-disable-next-line */ }, [streamId]);

  if (!items.length) return null;
  const accept = async (rid) => { await api.post("/cohost/accept", { request_id: rid }); toast.success("Cohost accepted"); load(); };
  const decline = async (rid) => { await api.post("/cohost/decline", { request_id: rid }); load(); };

  return (
    <div className="rounded-2xl border border-nexus-gold/40 bg-nexus-gold/5 p-3 space-y-2" data-testid="cohost-inbox">
      <div className="flex items-center gap-2 text-nexus-gold"><Users className="w-3.5 h-3.5" /><span className="text-[10px] tracking-[0.3em] uppercase font-display">// cohost requests · {items.length}</span></div>
      {items.map((r) => (
        <div key={r.id} className="flex items-center gap-2 bg-black/30 rounded-xl p-2" data-testid={`cohost-req-${r.id}`}>
          <img src={r.requester_avatar} alt="" className="w-8 h-8 rounded-full object-cover" />
          <div className="flex-1 min-w-0">
            <div className="text-sm font-display font-bold truncate">{r.requester_name}</div>
            <div className="text-[10px] text-white/60 truncate">{r.message || "wants to join your stream"}</div>
          </div>
          <button onClick={() => accept(r.id)} className="rounded-full bg-nexus-mint text-black p-1.5" data-testid={`cohost-accept-${r.id}`}><UserCheck className="w-3.5 h-3.5" /></button>
          <button onClick={() => decline(r.id)} className="rounded-full bg-white/10 text-white p-1.5" data-testid={`cohost-decline-${r.id}`}><UserX className="w-3.5 h-3.5" /></button>
        </div>
      ))}
    </div>
  );
}
